export default function ({ store, route, redirect }) {
  // route.meta is an array; find the first instance of requiredAddons
  const required = route.meta.find((m) => 'requiredAddons' in m);

  if (!required) return;

  const requiredAddons = Array.isArray(required.requiredAddons) ? required.requiredAddons : [required.requiredAddons];

  const hasAll = requiredAddons.every((addon) => store.getters['user/hasEnabledAddon'](addon));

  if (!hasAll) {
    return redirect('/');
  }
}
